var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            "panel-title": "Thông tin chung",
            "panel-subtitle": "Vui lòng điền đầy đủ thông tin",
            "panel-icon": "el-icon-document-add",
            visible: _vm.dialogVisible,
            size: "xl",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "2vh",
            title: "Thêm thực đơn",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "tab-infor-button" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "medium" },
                          on: {
                            click: function ($event) {
                              return _vm.closeDialogByButton(
                                "createTabAllClassMenu"
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-circle-close" }),
                          _c("span", [_vm._v("Đóng")]),
                        ]
                      ),
                      _vm.checkPermission(["studentQuality_menu_update"])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "medium",
                                loading: _vm.loadingButton,
                                mini: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("createTabAllClassMenu")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-circle-check" }),
                              _c("span", [_vm._v("Lưu")]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              ref: "createTabAllClassMenu",
              attrs: {
                "label-width": "140px",
                "label-position": "left",
                model: _vm.createMultiClassMenu,
              },
            },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeNameTab,
                    callback: function ($$v) {
                      _vm.activeNameTab = $$v
                    },
                    expression: "activeNameTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 2", name: "monday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.createMultiClassMenu
                                  .createTabAllClassMenu[0].createTabDayInWeek,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "150px",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 4,
                                            placeholder: "Nhập thực đơn...",
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("el-upload", {
                                              ref: "uploadImageMenu",
                                              staticClass: "upload_image",
                                              class: {
                                                "hide-upload":
                                                  !!scope.row.urlImgMenuWeb,
                                              },
                                              attrs: {
                                                action: "#",
                                                "list-type": "picture-card",
                                                "on-preview":
                                                  _vm.handlePictureCardPreview,
                                                "on-remove": () =>
                                                  _vm.handleRemoveImage(
                                                    scope.row
                                                  ),
                                                "on-change": (value) =>
                                                  _vm.handleChangeImage(
                                                    scope.row,
                                                    value
                                                  ),
                                                "auto-upload": false,
                                                multiple: false,
                                                accept: "image/*",
                                                limit: 1,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "trigger",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-plus",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "16px",
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  "margin-top":
                                                                    "4px",
                                                                  "line-height":
                                                                    "1.2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Thêm ảnh"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              0
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2930987014
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 3", name: "tuesday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.createMultiClassMenu
                                  .createTabAllClassMenu[1].createTabDayInWeek,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "150px",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("el-upload", {
                                              ref: "uploadImageMenu",
                                              staticClass: "upload_image",
                                              class: {
                                                "hide-upload":
                                                  !!scope.row.urlImgMenuWeb,
                                              },
                                              attrs: {
                                                action: "#",
                                                "list-type": "picture-card",
                                                "on-preview":
                                                  _vm.handlePictureCardPreview,
                                                "on-remove": () =>
                                                  _vm.handleRemoveImage(
                                                    scope.row
                                                  ),
                                                "on-change": (value) =>
                                                  _vm.handleChangeImage(
                                                    scope.row,
                                                    value
                                                  ),
                                                "auto-upload": false,
                                                multiple: false,
                                                accept: "image/*",
                                                limit: 1,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "trigger",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-plus",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "16px",
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  "margin-top":
                                                                    "4px",
                                                                  "line-height":
                                                                    "1.2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Thêm ảnh"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              1
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2724730695
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 4", name: "wednesday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.createMultiClassMenu
                                  .createTabAllClassMenu[2].createTabDayInWeek,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "150px",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("el-upload", {
                                              ref: "uploadImageMenu",
                                              staticClass: "upload_image",
                                              class: {
                                                "hide-upload":
                                                  !!scope.row.urlImgMenuWeb,
                                              },
                                              attrs: {
                                                action: "#",
                                                "list-type": "picture-card",
                                                "on-preview":
                                                  _vm.handlePictureCardPreview,
                                                "on-remove": () =>
                                                  _vm.handleRemoveImage(
                                                    scope.row
                                                  ),
                                                "on-change": (value) =>
                                                  _vm.handleChangeImage(
                                                    scope.row,
                                                    value
                                                  ),
                                                "auto-upload": false,
                                                multiple: false,
                                                accept: "image/*",
                                                limit: 1,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "trigger",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-plus",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "16px",
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  "margin-top":
                                                                    "4px",
                                                                  "line-height":
                                                                    "1.2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Thêm ảnh"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              2
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1419767556
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 5", name: "thursday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.createMultiClassMenu
                                  .createTabAllClassMenu[3].createTabDayInWeek,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "150px",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("el-upload", {
                                              ref: "uploadImageMenu",
                                              staticClass: "upload_image",
                                              class: {
                                                "hide-upload":
                                                  !!scope.row.urlImgMenuWeb,
                                              },
                                              attrs: {
                                                action: "#",
                                                "list-type": "picture-card",
                                                "on-preview":
                                                  _vm.handlePictureCardPreview,
                                                "on-remove": () =>
                                                  _vm.handleRemoveImage(
                                                    scope.row
                                                  ),
                                                "on-change": (value) =>
                                                  _vm.handleChangeImage(
                                                    scope.row,
                                                    value
                                                  ),
                                                "auto-upload": false,
                                                multiple: false,
                                                accept: "image/*",
                                                limit: 1,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "trigger",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-plus",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "16px",
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  "margin-top":
                                                                    "4px",
                                                                  "line-height":
                                                                    "1.2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Thêm ảnh"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              3
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3847270981
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 6", name: "friday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.createMultiClassMenu
                                  .createTabAllClassMenu[4].createTabDayInWeek,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "150px",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("el-upload", {
                                              ref: "uploadImageMenu",
                                              staticClass: "upload_image",
                                              class: {
                                                "hide-upload":
                                                  !!scope.row.urlImgMenuWeb,
                                              },
                                              attrs: {
                                                action: "#",
                                                "list-type": "picture-card",
                                                "on-preview":
                                                  _vm.handlePictureCardPreview,
                                                "on-remove": () =>
                                                  _vm.handleRemoveImage(
                                                    scope.row
                                                  ),
                                                "on-change": (value) =>
                                                  _vm.handleChangeImage(
                                                    scope.row,
                                                    value
                                                  ),
                                                "auto-upload": false,
                                                multiple: false,
                                                accept: "image/*",
                                                limit: 1,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "trigger",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-plus",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "16px",
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  "margin-top":
                                                                    "4px",
                                                                  "line-height":
                                                                    "1.2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Thêm ảnh"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              4
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      662038018
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thứ 7", name: "saturday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.createMultiClassMenu
                                  .createTabAllClassMenu[5].createTabDayInWeek,
                                "header-cell-style": _vm.tableHeaderColor,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "150px",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("el-upload", {
                                              ref: "uploadImageMenu",
                                              staticClass: "upload_image",
                                              class: {
                                                "hide-upload":
                                                  !!scope.row.urlImgMenuWeb,
                                              },
                                              attrs: {
                                                action: "#",
                                                "list-type": "picture-card",
                                                "on-preview":
                                                  _vm.handlePictureCardPreview,
                                                "on-remove": () =>
                                                  _vm.handleRemoveImage(
                                                    scope.row
                                                  ),
                                                "on-change": (value) =>
                                                  _vm.handleChangeImage(
                                                    scope.row,
                                                    value
                                                  ),
                                                "auto-upload": false,
                                                multiple: false,
                                                accept: "image/*",
                                                limit: 1,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "trigger",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-plus",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "16px",
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  "margin-top":
                                                                    "4px",
                                                                  "line-height":
                                                                    "1.2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Thêm ảnh"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              5
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1711566659
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "CN", name: "sunday" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                "header-cell-style": _vm.tableHeaderColor,
                                data: _vm.createMultiClassMenu
                                  .createTabAllClassMenu[6].createTabDayInWeek,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sessionDay",
                                  label: "Buổi",
                                  align: "center",
                                  width: "150px",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "timeContent",
                                  label: "Thời gian",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Nhập thời gian...",
                                          },
                                          model: {
                                            value: scope.row.timeContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "timeContent",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.timeContent",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contentClassMenu",
                                  label: "Nội dung",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Nhập thực đơn...",
                                            rows: 4,
                                          },
                                          model: {
                                            value: scope.row.contentClassMenu,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contentClassMenu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contentClassMenu",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ảnh",
                                  align: "center",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("el-upload", {
                                              ref: "uploadImageMenu",
                                              staticClass: "upload_image",
                                              class: {
                                                "hide-upload":
                                                  !!scope.row.urlImgMenuWeb,
                                              },
                                              attrs: {
                                                action: "#",
                                                "list-type": "picture-card",
                                                "on-preview":
                                                  _vm.handlePictureCardPreview,
                                                "on-remove": () =>
                                                  _vm.handleRemoveImage(
                                                    scope.row
                                                  ),
                                                "on-change": (value) =>
                                                  _vm.handleChangeImage(
                                                    scope.row,
                                                    value
                                                  ),
                                                "auto-upload": false,
                                                multiple: false,
                                                accept: "image/*",
                                                limit: 1,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "trigger",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-plus",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "16px",
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  "margin-top":
                                                                    "4px",
                                                                  "line-height":
                                                                    "1.2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Thêm ảnh"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.checkPermission([
                                "studentQuality_menu_update",
                              ])
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                    "align-items": "center",
                                                    gap: "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content: "Xóa",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRow(
                                                              scope.$index,
                                                              6
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      406603520
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "50px" } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "button-click-left" },
                      [
                        _c(
                          "el-row",
                          { attrs: { type: "flex", gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "week",
                                    "value-format": "yyyy-MM-dd",
                                    format: "Tuần WW",
                                    placeholder: "Chọn tuần",
                                    clearable: false,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getValueDateClassMenu(
                                        _vm.createTimeClassMenu
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.createTimeClassMenu,
                                    callback: function ($$v) {
                                      _vm.createTimeClassMenu = $$v
                                    },
                                    expression: "createTimeClassMenu",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 16 } },
                              [
                                _c("el-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    multiple: "",
                                    placeholder: "Tuần đã chọn",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeWeek()
                                    },
                                  },
                                  model: {
                                    value: _vm.listCreateTimeClassMenu,
                                    callback: function ($$v) {
                                      _vm.listCreateTimeClassMenu = $$v
                                    },
                                    expression: "listCreateTimeClassMenu",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "button-left",
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "Chọn lớp",
                              clearable: true,
                              multiple: true,
                            },
                            model: {
                              value: _vm.createMultiClassMenu.listIdClass,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.createMultiClassMenu,
                                  "listIdClass",
                                  $$v
                                )
                              },
                              expression: "createMultiClassMenu.listIdClass",
                            },
                          },
                          _vm._l(_vm.classListCommon, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.className, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }